var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLastItem = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 346,
  height: 184,
  viewBox: "0 0 346 184",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "9z2je9cxya",
  d: "M0 0h244v175H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.354 6.792.482 11.944 17.393 63.55a5.472 5.472 0 0 0 6.905 3.496c9.398-2.183 18.768-17.96 16.25-25.644L26.99.03 6.355 6.792z",
  id: "8hlju6j4cc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.482 6.944 17.285 52.748a4.27 4.27 0 0 0 5.389 2.73l4.532-1.486c6.652-2.18 10.279-9.34 8.099-15.992L21.119.181.482 6.944z",
  id: "yoh8ebzede"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.482 6.944 1.841 5.618C7.23 7.034 15.669 6.05 23.436 7.256L21.12.181.482 6.944z",
  id: "pydpjlscvg"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.536 29.608.304.927C5.868 42.83 19.1 49.53 31.393 45.502L16.502.053C4.207 4.082-2.492 17.314 1.536 29.608z",
  id: "5slo90iswi"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.093 69.797c-1.493.511-2.662 1.706-3.064 3.231-.947 3.6-1.826 11.112 2.006 22.808 3.833 11.696 8.987 17.232 11.88 19.572 1.229.992 2.878 1.263 4.384.79 58.053-18.205 129.356-8.509 129.356-8.509l-17.628-53.793L113.4.102s-12.507 12.09-32.065 26.72C61.116 41.95 33.36 59.793 4.094 69.797z",
  id: "7wmmkofj1k"
}), /*#__PURE__*/React.createElement("path", {
  id: "r9gq6y632m",
  d: "M.497.068H53.82v114.73H.497z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.028.068a7.348 7.348 0 0 0-.942.072C3.675 1.04.411 10.19.498 16.825c.212 15.909 3.37 31.42 8.32 46.528 4.784 14.598 11.019 29.702 20.665 41.824 2.7 3.395 6.07 7.326 10.279 8.864 1.413.517 2.689.754 3.838.757h.042c8.643-.02 10.178-13.315 10.178-20.542v-.017c0-.278-.002-.547-.006-.805-.239-14.298-3.697-28.637-8.129-42.161-4.052-12.367-9.188-24.627-16.248-35.601-3.338-5.19-7.511-10.747-12.909-13.929C14.59.6 12.822.088 11.228.068h-.2z",
  id: "zji0cxtx6o"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.028.068a7.354 7.354 0 0 0-.942.072C3.675 1.04.411 10.19.498 16.825c.212 15.909 3.37 31.42 8.32 46.528 4.784 14.598 11.019 29.702 20.665 41.824 2.7 3.395 6.07 7.326 10.279 8.864 1.413.517 2.689.754 3.838.757h.042c8.643-.02 10.178-13.315 10.178-20.542v-.017c0-.278-.002-.547-.006-.805-.239-14.298-3.697-28.637-8.129-42.161-4.052-12.367-9.188-24.627-16.248-35.601-3.338-5.19-7.511-10.747-12.909-13.929C14.59.6 12.822.088 11.228.068h-.2z",
  id: "zbtf8yvp0q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.554.278c-8.64 2.83-8.024 28.38 1.375 57.064 9.4 28.686 24.024 49.644 32.664 46.813 8.641-2.832 8.026-28.382-1.374-57.066C30.391 20.147 16.953.021 8.193.021c-.566 0-1.113.084-1.638.257z",
  id: "u9mitefo2s"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.929 46.843c6.12 18.675 14.453 34.067 21.909 41.76 1.457-10.613-.936-27.952-7.056-46.627C16.663 23.3 8.33 7.905.874.214c-1.458 10.613.935 27.953 7.055 46.627z",
  id: "lfhwlfvy7u"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.147 14.527c-2.454.839-4.304 2.804-4.949 5.257-.992 3.766-2.045 11.95 2.055 24.464 4.1 12.513 9.793 18.488 12.822 20.935 1.971 1.596 4.626 2.085 7.1 1.309 11.183-3.506 22.903-5.954 34.523-7.635-1.292.07-2.8-.75-4.416-2.312-4.245-4.102-9.22-13.26-12.893-24.471-3.671-11.203-5.083-21.523-4.093-27.345.371-2.184 1.087-3.726 2.144-4.45-10.345 5.51-21.223 10.463-32.293 14.248z",
  id: "6m5u2xqmqx"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.543.46.565.451V.45a.248.248 0 0 1-.02.01z",
  id: "jql58j8k3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.642.291.193-.03-.003-.01C.77.27.706.277.641.291z",
  id: "v5v5dkbkaB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.44.778c.2-.107.404-.21.604-.318a2.627 2.627 0 0 0-.605.318z",
  id: "6x9ivxz1tD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.199.357C.35.35.497.325.643.291.495.312.347.336.199.358z",
  id: "fdz0s2v14F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.601.434c-.013.005-.025.013-.037.018-.007.002-.013.006-.02.009-.2.107-.405.21-.605.317C1.883 1.504 1.167 3.045.796 5.23c-.99 5.822.422 16.141 4.093 27.345 3.673 11.21 8.648 20.37 12.893 24.471 1.616 1.563 3.124 2.382 4.417 2.313.148-.022.296-.046.443-.067.064-.015.128-.021.19-.04.012-.004.026-.004.04-.009 1.136-.372 1.956-1.53 2.468-3.301a286.61 286.61 0 0 0-3.369.467c-.006.008-.013.021-.019.027-.014-.001-.033-.012-.049-.015l-.002-.001c-1.988-.386-8.69-7.851-14.23-24.757C2.149 14.807 3.11 4.837 4.478 3.302a.138.138 0 0 0 .014-.02c.01-.014.02-.03.03-.041.012.002.03.012.043.015a288.243 288.243 0 0 0 2.99-1.615C6.426.772 5.368.305 4.422.305a2.63 2.63 0 0 0-.822.129z",
  id: "fud455c5qH"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.401.419c.015.003.035.015.051.017C.458.428.465.415.471.407l-.07.011z",
  id: "jjs4c32wkJ"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.477.302.566.257C.552.253.534.243.521.241.505.257.491.286.476.302z",
  id: "6c51seyvqL"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.22.237C13.752 2.265 6.99 3.715.26 4.741a173.356 173.356 0 0 0 4.668 17.102c2.171 6.624 4.623 12.829 7.212 18.43 5.97-3.112 12.21-5.907 18.553-8.075 1.51-.516 2.647-1.725 3.044-3.233.61-2.317 1.258-7.351-1.264-15.047-2.521-7.696-6.023-11.37-7.886-12.877A4.636 4.636 0 0 0 21.665.016a4.82 4.82 0 0 0-1.444.222z",
  id: "14se9qx32N"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.559.31c-2.133.7-1.922 7.189.472 14.495 2.395 7.307 6.065 12.663 8.198 11.965 2.133-.7 1.921-7.189-.473-14.495C7.503 5.397 4.12.248 1.951.248c-.136 0-.266.02-.392.061z",
  id: "lv27s0r1kP"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.132.456A3.926 3.926 0 0 0 .624 5.41l1.681 5.13a3.926 3.926 0 0 0 7.461-2.445L8.085 2.964A3.926 3.926 0 0 0 4.355.26c-.405 0-.817.064-1.223.196z",
  id: "q8t34p5naR"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.711.128 2.12.302A2.623 2.623 0 0 0 .367 3.627l1.779 5.475a2.968 2.968 0 0 0 3.908 1.837l.322-.127a2.262 2.262 0 0 0 1.348-2.721L5.955 1.85A2.547 2.547 0 0 0 2.711.128z",
  id: "j0kp01ykjT"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.199.132A2.56 2.56 0 0 0 .535 3.268l1.634 5.725a2.56 2.56 0 0 0 4.925-1.405L5.457 1.862A2.562 2.562 0 0 0 2.998.003a2.57 2.57 0 0 0-.798.129z",
  id: "bjq6r672yV"
}), /*#__PURE__*/React.createElement("filter", {
  id: "d0qdum0mww"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.392157 0 0 0 0 0.403922 0 0 0 0 0.937255 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 9)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ty6vx1y1rb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#9z2je9cxya"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#ty6vx1y1rb)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 135.798)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ils8j05rsd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#8hlju6j4cc"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#ils8j05rsd)",
  d: "M-10.883 78.686h63.21v-90.021h-63.21z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 140.798)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "w7hhkl7lwf",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#yoh8ebzede"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#w7hhkl7lwf)",
  d: "M-10.883 74h58.668v-85.183h-58.668z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m47.688 201.734-4.532 1.485a4.27 4.27 0 0 1-5.389-2.729l-17.285-52.749 20.636-6.762 14.669 44.762c2.18 6.653-1.446 13.813-8.099 15.993z",
  stroke: "#0E3474",
  strokeWidth: 2,
  fill: "#CCD8FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.437 148.053-2.318-7.074-20.637 6.762 1.841 5.618c4.907-5.528 13.347-6.51 21.114-5.306",
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 140.798)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "7m55lusvyh",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pydpjlscvg"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#7m55lusvyh)",
  d: "M-10.883 23.927h45.685v-35.11h-45.684z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M23.393 144.298C11.1 148.326-2.132 141.626-6.16 129.333l-.304-.928C-10.493 116.111-3.792 102.88 8.5 98.851l14.892 45.447z",
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-8 98.797)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "k2eovm4icj",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5slo90iswi"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#k2eovm4icj)",
  d: "M-11 58.036h53.758V-11.31H-11z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1 30.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "78pisg918l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#7wmmkofj1k"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#D8D8D8",
  xlinkHref: "#7wmmkofj1k"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#78pisg918l)",
  d: "M-11.152 127.79H160.02V-11.263h-171.17z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.03 103.326c-.949 3.599-1.827 11.112 2.005 22.808 3.833 11.696 8.987 17.231 11.88 19.571 1.228.992 2.878 1.264 4.384.79 58.053-18.205 129.355-8.509 129.355-8.509l-17.627-53.793L112.4 30.399s-12.506 12.09-32.063 26.72c-20.22 15.128-47.977 32.97-77.242 42.976-1.494.51-2.663 1.705-3.065 3.231z",
  stroke: "#0E3474",
  strokeWidth: 2,
  fill: "#CCD8FF"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(101.5 27.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d8iqh7rm7n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#r9gq6y632m"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.086.14C3.675 1.04.41 10.19.498 16.825c.212 15.91 3.37 31.421 8.32 46.528 4.783 14.598 11.018 29.702 20.665 41.825 2.7 3.394 6.07 7.325 10.279 8.864 12.499 4.568 14.183-12.721 14.051-20.608-.238-14.298-3.696-28.637-8.128-42.161-4.052-12.367-9.188-24.626-16.248-35.601-3.338-5.19-7.511-10.746-12.91-13.929C14.115.32 11.966-.125 10.088.14",
  fill: "#0E3474",
  mask: "url(#d8iqh7rm7n)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(101.5 27.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "zd7dcl9xrp",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#zji0cxtx6o"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#zd7dcl9xrp)",
  d: "M-1.029 115.52h56.825V-.403H-1.03z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(101.5 27.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "agef94gh1r",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#zbtf8yvp0q"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#agef94gh1r)",
  d: "M-10.868 126.163h76.053v-137.46h-76.053z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(107 31.797)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "6iwqwwi44t",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#u9mitefo2s"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#6467EF",
  xlinkHref: "#u9mitefo2s"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6467EF",
  mask: "url(#6iwqwwi44t)",
  d: "M-10.909 115.775h68.966V-11.344h-68.966z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M107.874 42.512c-1.457 10.614.935 27.953 7.055 46.628 6.12 18.676 14.453 34.068 21.909 41.76 1.457-10.612-.935-27.952-7.055-46.627-6.12-18.675-14.453-34.069-21.909-41.76",
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(107 42.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ptsf3ms4ov",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lfhwlfvy7u"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#ptsf3ms4ov)",
  d: "M-10.905 99.968h52.522V-11.15h-52.522z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#d0qdum0mww)",
  transform: "translate(-8 27)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 55.797)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "dwog9qti1y",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#6m5u2xqmqx"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#dwog9qti1y)",
  d: "M-11.069 78.219h80.133v-89.306h-80.132z"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M49.282 139.343c-4.245-4.102-9.22-13.261-12.893-24.472-3.671-11.202-5.083-21.523-4.093-27.344.372-2.185 1.087-3.726 2.143-4.452-10.344 5.512-21.223 10.464-32.292 14.25-2.453.838-4.304 2.803-4.95 5.256-.992 3.766-2.044 11.951 2.056 24.464 4.1 12.513 9.793 18.488 12.821 20.936 1.972 1.595 4.627 2.084 7.101 1.309 11.183-3.507 22.903-5.955 34.524-7.635-1.293.07-2.801-.75-4.417-2.312z",
  stroke: "#0E3474"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.5 82.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rgox8h946A",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#jql58j8k3z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4E35E7",
  mask: "url(#rgox8h946A)",
  d: "M-10.822 11.825h22.75v-22.74h-22.75z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53.5 141.298)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "aeseb09erC",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#v5v5dkbkaB"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4E35E7",
  mask: "url(#aeseb09erC)",
  d: "M-10.722 11.656H12.2v-22.77h-22.922z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34 82.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "90zwaxk7lE",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#6x9ivxz1tD"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  mask: "url(#90zwaxk7lE)",
  d: "M-10.925 12.143h23.334v-23.047h-23.334z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53.5 141.298)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "8o2b5zk5pG",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fdz0s2v14F"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  mask: "url(#8o2b5zk5pG)",
  d: "M-11.166 11.723h23.174v-22.797h-23.174z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.84 138.238c-1.121.149-2.245.305-3.369.468-.006.007-.012.02-.02.027-.013-.002-.032-.012-.047-.015l-.003-.001c-1.988-.387-8.69-7.852-14.23-24.758-5.523-16.854-4.56-26.825-3.194-28.359.005-.005.01-.012.015-.02.01-.015.02-.031.029-.041.013.002.03.012.044.015a292.674 292.674 0 0 0 2.989-1.615c-1.465-1.13-2.814-1.58-3.953-1.207-.013.004-.024.013-.037.017-.007.002-.013.006-.02.01-.2.107-.404.21-.604.317-1.057.725-1.772 2.266-2.144 4.451-.99 5.821.422 16.141 4.094 27.345 3.673 11.21 8.647 20.37 12.892 24.471 1.616 1.562 3.124 2.382 4.417 2.312.148-.022.296-.046.444-.067.063-.015.127-.02.189-.04.012-.003.027-.003.04-.008 1.136-.372 1.956-1.53 2.468-3.302",
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(31.5 82.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "0q1bpqtd8I",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fud455c5qH"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#0q1bpqtd8I)",
  d: "M-10.876 70.727h47.581V-11.06h-47.581z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53 138.298)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "61ozje2j7K",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#jjs4c32wkJ"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  mask: "url(#61ozje2j7K)",
  d: "M-10.964 11.8h22.8v-22.756h-22.8z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(35.5 85.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "opyk0fzm5M",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#6c51seyvqL"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  mask: "url(#opyk0fzm5M)",
  d: "M-10.887 11.668H11.93v-22.791h-22.817z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(110 67.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "3j64f7fxjO",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#14se9qx32N"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#D8D8D8",
  xlinkHref: "#14se9qx32N"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFBFB",
  mask: "url(#3j64f7fxjO)",
  d: "M-11.105 51.639h56.762v-62.99h-56.762z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(131.5 69.297)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "9c6nym0m8Q",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lv27s0r1kP"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#9c6nym0m8Q)",
  d: "M-11.277 38.196h34.342v-49.312h-34.342z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M38.758 169.846a3.926 3.926 0 0 1-4.953-2.508l-1.681-5.13a3.926 3.926 0 0 1 7.46-2.446l1.683 5.13a3.927 3.927 0 0 1-2.509 4.954",
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(31.5 156.798)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "jqvf6zlhyS",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#q8t34p5naR"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#jqvf6zlhyS)",
  d: "M-10.937 24.61h32.265v-35.715h-32.265z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M38.455 159.647a2.548 2.548 0 0 0-3.244-1.721l-.591.174a2.62 2.62 0 0 0-1.752 3.325l1.779 5.474a2.968 2.968 0 0 0 3.908 1.837l.322-.126a2.263 2.263 0 0 0 1.348-2.722l-1.77-6.24z",
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(32.5 157.798)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "jnupsf9soU",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#j0kp01ykjT"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#6467EF",
  xlinkHref: "#j0kp01ykjT"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E3474",
  mask: "url(#jnupsf9soU)",
  d: "M-11.126 22.511h30.302v-33.876h-30.301z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33 157.798)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "37jxgwuybW",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bjq6r672yV"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#6467EF",
  xlinkHref: "#bjq6r672yV"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFBFB",
  mask: "url(#37jxgwuybW)",
  d: "M-10.93 22.217h29.487v-33.578H-10.93z"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M141.466 93.816c.675.39 1.286.431 1.731.184.004.004 48-9 56 39 3.384 20.307 6 48 35 51h103a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8h-189c13.018 8.145 27 25 24 43-3.965 23.79-23.153 36.56-31.954 44.826-.742.059-1.243.685-1.243 1.737 0 1.563 1.104 3.467 2.466 4.253z",
  fill: "#E8EDFF"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLastItem);
export default ForwardRef;